import React, { useState, useEffect, Suspense } from 'react'
import { Link, useParams } from 'react-router-dom';
import axios from 'axios'
import { Markup } from 'interweave';
import LoadingBar from 'react-top-loading-bar'
import {Helmet} from "react-helmet";
import InfiniteScroll from "react-infinite-scroller";

import Header from '../Header/Header';
import Sidebar from '../Sidebar/Sidebar';
import Footer from '../Footer/Footer';
import Spinner from '../Global/Spinner';
import VideoBox from '../Global/VideoBox';
import PlayAllButton from '../Global/PlayAllButton'

import styles from '../../App.module.css';
import classes from './Playlist.module.css'

import noThumb from "../../images/no-thumb.jpg";

function Playlist() {
    const { id, name } = useParams();
    const [album, setAlbum] = useState([]);
    const [videos, setVideos] = useState([]);
    const [hasMore, sethasMore] = useState(false);
    const [page, setpage] = useState(2);
    const [loading, setLoading] = useState(true);
    const [progress, setProgress] = useState(0);
    const [vid, setVid] = useState(null);

    useEffect(() => {
        setProgress(10);
        axios.post(`${process.env.REACT_APP_API_URL}/api/playlist.php`, {
            playlist_id: id,
            playlist_type: 2,
            action: 'ALBUM_DETAILLS'
        }, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        }).then(res => {
            // console.log(res.data);
            setAlbum(res.data);
        }).catch(err => {
            console.log(err);
        })
    } , [id, name]);

    useEffect(() => {
        setProgress(10);
        axios.post(`${process.env.REACT_APP_API_URL}/api/playlist.php`, {
            playlist_id: id,
            playlist_type: 1,
            action: 'GET_IMAGES'
        }, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        }).then(res => {
            // console.log(res.data);
            if(res.data.status !== 'error') {
                // console.log(res.data);
                setVideos(res.data);
                res.data.length < 12 && setVid(res.data[0].id);
                res.data.length < 12 ? sethasMore(false) : sethasMore(true);
            }
            setLoading(true);
            setProgress(100);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }).catch(err => {
            console.log(err);
        })
    } , [id, name])

    const loadMore = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/playlist.php`, {
            playlist_id: id,
            playlist_type: 1,
            action: 'GET_IMAGES'
        }, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        }).then(res => {
            if(res.data.message !== 'No videos found') {
                loading && hasMore && setVideos([...videos, ...res.data]);
                setpage(page + 1);
                
                res.data.length < 12 ? sethasMore(false) : sethasMore(true);
              }
        })
    }

    return (
        <>
            {
                <Helmet>
                    <title>{album.name || 'Playlist'} - Wesharez</title>
                    <meta name="description" content={album.description ? album.description.replace(/<[^>]*>?/gm, '').slice(0, 270) : 'Page'} />
                    <meta name="keywords" content="wesharez, youtube videos, musics, images, albums, earn money, Bookmarking, be a creator, share video, share your content, products, services, products and services, blog, latest articles, web pages, views, skin, science, days, review" />
                </Helmet>
            }
            <LoadingBar
                color='#f11946'
                progress={progress}
                onLoaderFinished={() => setProgress(0)}
            />
            <Header />
            <div className={styles.main_body}>
                <Suspense fallback="<div>Please wait...</div>">
                    <Sidebar />
                </Suspense>
                <Suspense fallback="<div>Please wait...</div>">
                    <div className={styles.main_content + ` main-content`}>
                        <div className={classes.album_component + ` p-4`}>
                            <div className={`${classes.card}`}>
                                <div className="row">
                                    <div className="col-md-8">
                                        <div className={classes.playlist_head}>
                                            <div className={classes.media_left}>
                                                <div className={classes.album_image}>
                                                    <img src={album.picture} onError={e => {e.target.src = noThumb}} alt="" />
                                                </div>
                                            </div>
                                            <div className={classes.media_body}>
                                                <h3 className={classes.media_heading}>{album.title}</h3>
                                                <h6 className={classes.creator}><em>Created By:</em> {album.owner}</h6>
                                                <p className='text-muted mb-2'><small>{album.description}</small></p>
                                                <b className="text-muted m-0"><small>Watched {album.views} times</small></b>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        {
                                            vid && <Link to={`/video/${vid}/playlist/${id}`}>{PlayAllButton('primary')}</Link>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className={`${classes.gallery} mt-4`}>
                                {
                                    <InfiniteScroll
                                        pageStart={0}
                                        loadMore={loadMore}
                                        hasMore={hasMore}
                                        loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                                        className='row'
                                    >
                                        {
                                            videos && videos.map && videos.map((video, index) => {
                                                return (
                                                    <>
                                                        {
                                                            video.id !== null && <div className={`${styles.item} col-lg-3 col-sm-6`} key={index}>
                                                                {
                                                                    VideoBox(video)
                                                                }
                                                            </div>
                                                        }
                                                    </>
                                                )
                                            })
                                        }
                                    </InfiniteScroll>
                                }
                            </div>
                        </div>
                        <Footer />
                    </div>
                </Suspense>
            </div>
        </>
    )
}

export default Playlist